import { Button, Checkbox, DatePicker, Divider, Input, Space } from 'antd';
import { getTranslatedString } from 'helpers/i18n';
import React, { useContext, useState } from 'react';
import { ApplicationUIContext, Drawer, DrawerContent, Form } from 'ui-library';
import { requiredRule } from '../common/Rules';
import { InlineFormItem } from '../common/StyledComponents';

const defaultInitialValues = {};

const IncentiveCodeDrawer = ({ drawer, onAdd, initialValues = defaultInitialValues }) => {
  const { isMobile } = useContext(ApplicationUIContext);
  const [form] = Form.useForm();
  const [disabled, setDisabled] = useState(initialValues?.wont_expire || false);
  const validFrom = Form.useWatch('valid_from', form);
  const validTo = Form.useWatch('valid_to', form);

  const handleDrawerClose = () => {
    form.resetFields();
    setDisabled(false);
    drawer.close();
  };

  const onDoesNotExpireChange = (e) => {
    if (e.target.checked) {
      form.setFieldsValue({ valid_to: null });
    }
    setDisabled(e.target.checked);
  };

  const disabledValidFromDate = (current) => current && validTo && current > validTo;

  const disabledValidToDate = (current) => current && current < validFrom;

  return (
    <Drawer
      title="Add a code"
      visible={drawer.isVisible}
      closable
      destroyOnClose
      onClose={handleDrawerClose}
    >
      <DrawerContent>
        <Form
          layout="vertical"
          size={isMobile && 'large'}
          form={form}
          name="incentive-code-form"
          scrollToFirstError
          initialValues={initialValues}
          onFinish={(values) => {
            onAdd(values);
            handleDrawerClose();
          }}
        >
          <Form.Item
            name="code"
            label={getTranslatedString('landlordPortal.incentives.code')}
            rules={[requiredRule]}
            hasFeedback
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="valid_from"
            label={getTranslatedString('landlordPortal.incentives.validFrom')}
            rules={[requiredRule]}
          >
            <DatePicker placeholder="" disabledDate={disabledValidFromDate} />
          </Form.Item>

          <InlineFormItem
            name="wont_expire"
            label={getTranslatedString('landlordPortal.incentives.doesNotExpire')}
            valuePropName="checked"
          >
            <Checkbox onChange={onDoesNotExpireChange} />
          </InlineFormItem>

          <Form.Item
            name="valid_to"
            label={getTranslatedString('landlordPortal.incentives.validTo')}
            rules={[!disabled && requiredRule].filter(Boolean)}
          >
            <DatePicker placeholder="" disabled={disabled} disabledDate={disabledValidToDate} />
          </Form.Item>

          <Divider />

          <Space direction="horizontal">
            <Button type="primary" htmlType="submit">
              {getTranslatedString('add')}
            </Button>

            <Button type="secondary" onClick={handleDrawerClose}>
              {getTranslatedString('cancel')}
            </Button>
          </Space>
        </Form>
      </DrawerContent>
    </Drawer>
  );
};

export default IncentiveCodeDrawer;
